import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Admin } from "../../types";
import backBtn from "../../assets/icons/arrow_left.svg";
import FormInput from "../../components/FormInput";

interface AdminDetailsModalProps {
  showModal: boolean;
  onHide: () => void;
  adminId: string;
  formatDate: (date: string) => string;
  capitalizeFirstLetter: (str: string) => string;
  details: Admin;
}

const AdminDetailsModal = ({ showModal, onHide, capitalizeFirstLetter, formatDate, details }: AdminDetailsModalProps) => {
	const [isLoading, setIsLoading] = useState(false);

	if (!showModal) return null;

	return (
		<>
			<div className="modal-backdrop" onClick={onHide}></div>
				<div className="modal-container">
					<div className="book-details-body">
						<div className="custom-modal-header">
							<div className="custom-back">
								<img src={backBtn} alt="back" onClick={onHide} />
								<h4>Administrator Details</h4>
							</div>

							<Button className="custom-button">Edit</Button>
						</div>

						{isLoading ? (
							<div className="spinner-div">
								<Spinner animation="border" size="sm" role="status" />
							</div>
						) : (
							<div className="custom-modal-body">
								<div className="detail-section">
									<FormInput
										label="First Name"
										name="name"
										className="detail-input"
										value={details?.first_name}
										readOnly
									/>

									<FormInput
										label="Last Name"
										name="name"
										className="detail-input"
										value={details?.last_name}
										readOnly
									/>
					
									<FormInput
										label="Email"
										name="email"
										className="detail-input"
										value={details?.email}
										readOnly
									/>
						
									<FormInput
										label="Admin Type"
										name="type"
										className="detail-input"
										value={capitalizeFirstLetter(details?.user_type)}
										readOnly
									/>
					
									<FormInput
										label="Date Joined"
										name="created_at"
										className="detail-input"
										value={formatDate(details?.created_at)}
										readOnly
										/>
								</div>
							</div>
						)}
					</div>
				</div>
		</>
	)
};

export default AdminDetailsModal;